module.exports = __webpack_public_path__ + "static/nodejs-d617748f19137ac2a7b624ef09040bdc.png";